import {
  UPDATE_ACTIVITY_COUNT
} from '../constants';

const userActivities = (state = {}, action) => {
  switch(action.type) {
    case UPDATE_ACTIVITY_COUNT:
      return {...state, ...action.counts}
    default:
      return state;
  }
}

export default userActivities;


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/reducers/userActivitiesReducer.js